import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=e95cad04&"
import script from "./BaseImage.vue?vue&type=script&lang=ts&"
export * from "./BaseImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports